<template>
  <div class="main">
    <landing></landing>
    <hero></hero>
    <!-- <about></about>
    <projects></projects>
    <contact></contact> -->
  </div>
</template>

<script>
import Landing from "../components/Landing"
import Hero from "../components/Hero"
import About from "../components/About"
import Projects from "../components/Projects"
import Contact from "../components/Contact"

export default {
  components: {
    Landing,
    Hero,
    Projects,
    About,
    Contact
  }
}
</script>

<style lang="css">
  .main {
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #A8A030;
    margin: 10px 0;
    padding: 0;
  }

  /* MOBILE RESPONSIVE */
	@media only screen and (max-width: 700px) {
    p {
      font-size: 18px;
    }
    h3 {
      font-size: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?fbb876b8